module.exports = __webpack_public_path__ + "img/C107.08bde8c4.jpg";